// import AccessUser from '../../plugins/AccessUser'
import httpService from "../../components/service";
import AccessUser from "../../plugins/AccessUser";

export const roles = {
    namespaced: true,
    state: {
        access: null,
        roles: null,
        rolesComplet: [],
        rolesAreBeingUpdated: false,
        profiles: null
    },
    getters: {
        getAllAccess(state) {
            return state.access;
        },
        getRoles(state) {
            return state.roles;
        },
        getProfiles(state) {
            return state.profiles;
        },
        getRolesComplete(state) {
            return state.rolesComplet;
        },
        getRolesAreBeingUpdated(state) {
            return state.rolesAreBeingUpdated;
        }
    },
    mutations: {
        FIND_ALL_ROLES(state, roles) {
            state.roles = roles;
        },
        FIND_ALL_ACCESS(state, access) {
            state.access = access;
        },
        FIND_ALL_ROLES_COMPLETE(state, roles) {
            state.rolesComplet = roles;
        },
        SET_ROLLS_ARE_BEING_UPDATED(state, rolesAreBeingUpdated) {
            state.rolesAreBeingUpdated = rolesAreBeingUpdated;
        },
        SET_PROFILES(state, profiles) {
            state.profiles = profiles;
        }
    },
    actions: {
        findAllRoles(context) {
            return httpService.get("/roles").then(res => {
                if (httpService.hasError(res)) return false;
                context.commit("FIND_ALL_ROLES", res.roles);
                context.commit("SET_PROFILES", res.profiles);
                return res;
            });
        },
        findAllRolesComplet(context) {
            return httpService.get("/admin/all/roles").then(res => {
                if (httpService.hasError(res)) return false;
                context.commit("FIND_ALL_ROLES_COMPLETE", res);
                let accesses = AccessUser.roleToBinary(res);
                context.commit("FIND_ALL_ACCESS", accesses);
                return res;
            });
        },
        setRolesAreBeingUpdated(context, rolesAreBeingUpdated) {
            context.commit("SET_ROLLS_ARE_BEING_UPDATED", rolesAreBeingUpdated);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/user/roles.js